'use strict';

angular.module('shiftTraderApp')
  .controller('ProfileAvailabilityCtrl', function ($scope, user, positions, me,
                                       pending_in_review_availability_sets, userAvailabilityChangeRequests,
                                       Session, ServerUrls, $uibModal, org, UserPermissionsService) {

    $scope.user = user;
    $scope.me = me;
    $scope.org = org;
    $scope.pending_in_review_availability_sets = pending_in_review_availability_sets;
    $scope.userAvailabilityChangeRequests = userAvailabilityChangeRequests;

    $scope.activeChangeRequest = _.find($scope.userAvailabilityChangeRequests, function(uacr) {
      return !uacr.$isExpired();
    });

    $scope.state = {
      hasChangeRequest: !_.isUndefined($scope.activeChangeRequest),
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'availability_sets.view_target',
      'availability_sets.create',
      'availability_sets.create_for_self'
    ];

    function processRawPermissions() {
      var rawPerms = $scope.state.rawPermissions;
      var myProf = $scope.me.id === $scope.user.id;

      $scope.state.derivedPermissions = {
        canCreate: myProf && rawPerms['availability_sets.create_for_self'] || !myProf && rawPerms['availability_sets.create'],
        canViewTarget: rawPerms['availability_sets.view_target']
      };
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;
        processRawPermissions();
      });

    $scope.state.hasSetPendingForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasPendingAvailabilitySet();
    $scope.state.hasSetInReviewForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasInReviewAvailabilitySet();
    $scope.state.hasSetApprovedForChangeRequest = $scope.state.hasChangeRequest && $scope.activeChangeRequest.$hasApprovedAvailabilitySet();

    $scope.state.needToRespondToChangeRequest = !$scope.state.hasSetInReviewForChangeRequest && !$scope.state.hasSetApprovedForChangeRequest;
    $scope.state.hasSetInReviewAfterApproval = $scope.state.hasChangeRequest && $scope.state.hasSetApprovedForChangeRequest && $scope.state.hasSetInReviewForChangeRequest;
    $scope.state.hasSetPendingAfterApproval = $scope.state.hasChangeRequest && $scope.state.hasSetApprovedForChangeRequest && $scope.state.hasSetPendingForChangeRequest;

    $scope.currentSet = _.find($scope.user.availability_sets, function(availSet) {
        return availSet.$isApproved() && availSet.$isInEffect() && availSet.active;
      });

    $scope.futureSet = _.find($scope.user.availability_sets, function(availSet) {
      return availSet.$isApproved() && !availSet.$isInEffect() && availSet.active;
    });

    $scope.inReviewSet = _.find($scope.pending_in_review_availability_sets, function(availSet) {
      return availSet.$isInReview() && availSet.active;
    });

    $scope.pendingSet = _.find($scope.pending_in_review_availability_sets, function(availSet) {
      return availSet.$isPending() && availSet.active;
    });



  });
